/**
 * Types of user actions supported on the mailtips infobar
 */
export enum MailTipsActionType {
    RemoveRecipient,
    ShowDetails,
    HideDetails,
    RemoveAll,
    ShowMore,
    ShowLess,
    EmailClicked,
    AccCheckerClick,
}

/**
 * Categories of mailtips supported for compose scenario
 */
export enum MailTipsCategory {
    None,
    OutOfOffice,
    LargeAudience,
    IsModerated,
    CustomMailTip,
    PreferAccessibleContent,
    MailboxFull,
    DeliveryRestricted,
    GuestsDisabledGroupsWithGuests,
    ExternalMemberCount,
}

/**
 * If the mailtip is displayed for a single recipient/multi recipient
 */
export enum MailTipsType {
    None,
    SingleRecipient,
    MultipleRecipients,
}

/**
 * Currently displayed mailtips map
 */
export interface MailTipsViewStateMap {
    AutomaticReply?: MailTipsType;
    LargeAudience?: MailTipsType;
    ModeratedMailbox?: MailTipsType;
    PrefersAccessibility?: MailTipsType;
    MailboxFull?: MailTipsType;
    DeliveryRestricted?: MailTipsType;
    GuestMailtip?: MailTipsType;
    ExternalMembers?: MailTipsType;
    CustomMailtip?: MailTipsType;
}

const customDataForAllShownMailtips = (mailTipsViewStateMap: MailTipsViewStateMap) => [
    mailTipsViewStateMap.AutomaticReply,
    mailTipsViewStateMap.LargeAudience,
    mailTipsViewStateMap.ModeratedMailbox,
    mailTipsViewStateMap.PrefersAccessibility,
    mailTipsViewStateMap.MailboxFull,
    mailTipsViewStateMap.DeliveryRestricted,
    mailTipsViewStateMap.GuestMailtip,
    mailTipsViewStateMap.ExternalMembers,
    mailTipsViewStateMap.CustomMailtip,
];

export default {
    UpdateMailtipsDatapoint: {
        datapoint: {
            name: 'UpdateMailtipsDatapoint',
            customData: (isEntryFetchedFromCache: boolean) => [isEntryFetchedFromCache],
        },
    },

    RecipientRemovedFromRecipientWellDatapoint: {
        datapoint: {
            name: 'RecipientRemovedFromRecipientWellDatapoint',
            customData: customDataForAllShownMailtips,
        },
    },

    MailtipsActionDatapoint: {
        datapoint: {
            name: 'MailtipsActionDatapoint',
            customData: (
                actionType: MailTipsActionType,
                mailtipCategory: MailTipsCategory,
                mailtipType: MailTipsType,
                recipientCount: number
            ) => [actionType, mailtipCategory, mailtipType, recipientCount],
        },
    },

    SendActionMailTipsDatapoint: {
        datapoint: {
            name: 'SendActionMailTipsDatapoint',
            customData: customDataForAllShownMailtips,
        },
    },

    DiscardActionMailTipsDatapoint: {
        datapoint: {
            name: 'DiscardActionMailTipsDatapoint',
            customData: customDataForAllShownMailtips,
        },
    },
};

export function roundOffCount(recipientCount: number): number {
    return recipientCount > 23 ? 23 : recipientCount;
}
